import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useToast } from '../components/Toast';
import { useAuth } from '../AuthContext';
import PlanPicker from './PlanPicker';
import { useUserProfile } from './useUserProfile';
import { planLabel } from './planTypes';

function tierClass(planType) {
  if (planType === 'karma') return 'yoga-tier yoga-tier--karma';
  if (planType === 'guided') return 'yoga-tier yoga-tier--guided';
  if (planType === 'teacher') return 'yoga-tier yoga-tier--teacher';
  return 'yoga-tier yoga-tier--guided';
}

export default function Membership() {
  const toast = useToast();
  const { user } = useAuth();
  const { profile, planType, loading, error, savePlanType } = useUserProfile();
  const [busy, setBusy] = useState(false);

  const onSelect = async (next) => {
    if (busy) return;
    setBusy(true);
    try {
      await savePlanType(next);
      toast(`Plan set to ${planLabel(next)}`, 'ok');
    } catch (err) {
      toast(`Could not save plan: ${err.message}`, 'danger', 8000);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="cs-page yoga-shell u-stack m-fade-in" style={{ '--gap': 'var(--sp-6)' }}>
      <header className="yoga-page-head m-rise">
        <p className="yoga-eyebrow">YogaKai</p>
        <h1 className="yoga-hero-title">Membership</h1>
        <p className="yoga-hero-lead">
          {user?.email ? (
            <>
              Signed in as <strong>{user.email}</strong>
              {planType ? (
                <>
                  {' '}
                  · <span className={tierClass(planType)}>{planLabel(planType)}</span>
                </>
              ) : null}
            </>
          ) : (
            'Sign in to manage your plan.'
          )}
        </p>
        <p className="cs-banner" role="status" style={{ margin: 0, maxWidth: '36rem' }}>
          Preview — billing is not connected. Switching plans updates your catalog instantly; no card is charged.
        </p>
      </header>

      {error && (
        <div className="cs-banner b-danger" role="alert">
          Could not load profile: {error}
        </div>
      )}

      {loading && (
        <p className="cs-help">
          <span className="cs-spinner" aria-hidden /> Loading your plan…
        </p>
      )}

      {!loading && !error && (
        <PlanPicker
          currentPlanType={planType}
          onSelect={onSelect}
          busy={busy}
          showPrices
          showBrand={false}
          title={profile ? 'Change your plan' : 'Choose your plan'}
          lead={
            profile
              ? 'Switch anytime — Karma sees the beginner Hatha pack; Guided unlocks the full library; Teacher adds the sequence builder.'
              : 'Pick how you want to practice or teach. You can change this later here.'
          }
        />
      )}

      <p className="u-muted u-small" style={{ margin: 0 }}>
        <Link to="/profile">Profile & preferences</Link>
        {' · '}
        <Link to="/today">Today</Link>
      </p>
    </div>
  );
}
